import { ActionDescription, ActionKind } from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { SerializedComponent } from "../../components/SerializedApp";
import { BaseActionHandler } from "./base";
import { ComponentBuilder } from "../components";

abstract class LegacyActionHandler extends BaseActionHandler<ActionDescription> {
    public get needsData(): boolean {
        return true;
    }
}

export class OpenLinkActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.OpenLink;
    public readonly iconName = "link";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Open Link",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.openLink(b.getContext));
    }
}

export class PhoneCallActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.PhoneCall;
    public readonly iconName = "phone";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Dial Phone Number",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.phoneCall(b.getContext));
    }
}

export class TextMessageActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.TextMessage;
    public readonly iconName = "message-circle";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Compose SMS",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.textMessage(b.getContext, undefined));
    }
}

export class CopyToClipboardActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.CopyToClipboard;
    public readonly iconName = "clipboard";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Copy to Clipboard",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.action("CopyToClipboard", { message: b.getContext }));
    }
}

export class OpenMapActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.OpenMap;
    public readonly iconName = "map-pin";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Show Address on Map",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.openMap(b.getContext));
    }
}

export class SendEmailActionHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.SendEmail;
    public readonly iconName = "mail";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Compose Email",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.sendEmail(b.getContext));
    }
}

export class ShowShareScreenHandler extends LegacyActionHandler {
    public readonly kind = ActionKind.ShowShareSheet;
    public readonly iconName = "share";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Share Link",
            isLegacy: true,
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent {
        const { b } = builder;
        return b.actionIfContextDefined(b.action("ShowShareSheet", { message: b.getContext }));
    }
}
